// extracted by mini-css-extract-plugin
export default {"container":"PopUpModal_container__GfNKH","closeModalIcon":"PopUpModal_closeModalIcon__FbbAg"};